import { FILTER_VALUES } from '@/utilities/constants'
import { snakeUp } from '@/utilities/filters'
import cloneDeep from 'lodash/cloneDeep'

export const bporDecodeSearchString = s => {
  const once = decodeURIComponent(s) || ''
  const twice = decodeURIComponent(once) || ''
  return twice ? JSON.parse(twice) : ''
}

export const getFilterItemOption = (o, v) => o?.find(i => i.value === v)

export const getFilterItemName = (o, v) => getFilterItemOption(o, v)?.name

export const getFilterValue = (name, value) => FILTER_VALUES[snakeUp(name)][snakeUp(value)]

export const setFilter = (context, payload) => {
  const currentFilter = cloneDeep(context.$store.getters['search/filter'])
  context.$store.commit('search/setFilter', { ...currentFilter, ...payload })
}
